/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import * as Examples from './Examples';
import {MultipleOneRow} from '../../extensions/forms/base-fields/String/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    pre: "pre",
    code: "code",
    p: "p",
    h3: "h3",
    a: "a"
  }, _provideComponents(), props.components);
  if (!Examples) _missingMdxReference("Examples", false);
  if (!Examples.CurrencyField) _missingMdxReference("Examples.CurrencyField", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Import"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import { Input } from '@dnb/eufemia'\n"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Description"
    }), "\n", _jsxs(_components.p, {
      children: ["The input component is an umbrella component for all inputs which share the same style as the classic ", _jsx(_components.code, {
        children: "text"
      }), " input field."]
    }), "\n", _jsx(_components.h3, {
      children: "Formatted input fields (masked values)"
    }), "\n", _jsxs(_components.p, {
      children: ["You may consider to use ", _jsx(_components.a, {
        href: "/uilib/components/input-masked/",
        children: "InputMasked"
      }), " for formatted strings and ", _jsx(_components.a, {
        href: "/uilib/extensions/forms/",
        children: "Eufemia Forms"
      }), " fields like ", _jsx(_components.a, {
        href: "/uilib/extensions/forms/base-fields/Number/",
        children: "Number"
      }), " and ", _jsx(_components.a, {
        href: "/uilib/extensions/forms/feature-fields/Currency/",
        children: "Currency"
      }), " for formatted numbers:"]
    }), "\n", _jsx(Examples.CurrencyField, {}), "\n", _jsx(_components.h3, {
      children: "Accessibility"
    }), "\n", _jsxs(_components.p, {
      children: ["Please avoid using the ", _jsx(_components.code, {
        children: "maxlength"
      }), " attribute when possible, as it may lower good accessibility. You can instead, use the ", _jsx(_components.a, {
        href: "/uilib/components/fragments/text-counter/",
        children: "TextCounter"
      }), " component."]
    }), "\n", _jsxs(_components.p, {
      children: ["But you may also consider to use a multiline input with a ", _jsx(_components.code, {
        children: "characterCounter"
      }), ":"]
    }), "\n", _jsx(MultipleOneRow, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
